export const jobs = [
  {
    company: "basement.studio",
    url: "https://basement.studio",
    position: "Desarrollador Front End",
    date: "2023 - Presente",
    city: "Mar del Plata",
    country: "Argentina",
    description: "",
    logo: "basement.svg",
  },
  {
    company: "Human Decode",
    url: "https://humandecode.com/es",
    position: "Desarrollador Full Stack JavaScript",
    date: "2021 - 2023",
    city: "San Francisco",
    country: "USA",
    description:
      "He participado en más de diez proyectos que abarcan desde sitios web completos con un fuerte énfasis en su UX/UI a productos full-stack, utilizando frameworks como Next.js (React) y Nuxt.js (Vue). Además, he creado interfaces de usuario complejas para varios sitios web, que implicaron tareas como implementar shaders personalizados con Three.js, crear animaciones con JavaScript base, animar SVGs, utilizar Framer Motion para transiciones complejas, entre otras.",
    logo: "human-decode.svg",
  },
];
